import React from 'react';
import { FaEdit, FaTrashAlt, FaLock } from 'react-icons/fa';
import styles from './ContactTypes.module.css';

const ContactTypeList = ({ 
    contactTypes, 
    loading, 
    onEdit, 
    onDelete, 
    searchQuery,
    setSearchQuery 
}) => {
    if (loading) {
        return (
            <div className={styles.loading}>
                <div className={styles.spinner}></div>
                <p>Loading contact types...</p>
            </div>
        );
    }

    if (contactTypes.length === 0 && !searchQuery) {
        return (
            <div className={styles.emptyState}>
                <h3>No Contact Types Found</h3>
                <p>Create your first contact type to get started.</p>
            </div>
        );
    }

    return (
        <div className={styles.listContainer}>
            {/* Table Header with Search */}
            <div className={styles.tableHeader}>
                <div className={styles.tableHeaderContent}>
                    <h3>Contact Types ({contactTypes.length})</h3>
                    <div className={styles.tableFilters}>
                        <div className={styles.filterGroup}>
                            <label htmlFor="searchFilter">Search:</label>
                            <input
                                id="searchFilter"
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Search by name or description..."
                                className={styles.searchInput}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.table}>
                <div className={styles.tableHead}>
                    <div className={styles.row}>
                        <div className={styles.cell}>Contact Type</div>
                        <div className={styles.cell}>Description</div>
                        <div className={styles.cell}>Actions</div>
                    </div>
                </div>
                <div className={styles.tableBody}>
                    {contactTypes.length === 0 && (
                        <div className={styles.noResults}>
                            <p>No contact types match your search criteria</p>
                        </div>
                    )}
                    {contactTypes.map(type => {
                        const isLocked = type.contactType === 'Billing' || type.contactType === 'Analytical Results';
                        return (
                            <div key={type.contactTypeId} className={styles.contactTypeRow}>
                                <div className={styles.row}>
                                    <div className={styles.cell}>
                                        <div className={styles.nameCell}>
                                            <span className={styles.name}>
                                                {type.contactType}
                                                {isLocked && <FaLock className={styles.lockIcon} title="This contact type cannot be altered" />}
                                            </span>
                                            <span className={styles.id}>ID: {type.contactTypeId}</span>
                                        </div>
                                    </div>
                                    <div className={styles.cell}>
                                        <div className={styles.description}>
                                            {type.description || <span className={styles.noDescription}>No description</span>}
                                        </div>
                                    </div>
                                    <div className={styles.cell}>
                                        <div className={styles.actions}>
                                            <button
                                                className={styles.editButton}
                                                onClick={() => onEdit(type)}
                                                title="Edit"
                                            >
                                                <FaEdit />
                                            </button>
                                            <button
                                                className={styles.deleteButton}
                                                onClick={() => onDelete(type.contactTypeId)}
                                                title="Delete"
                                            >
                                                <FaTrashAlt />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default ContactTypeList;
